import React from 'react'
import PropTypes from 'prop-types'

import { BrManageContentButton } from '@bloomreach/react-sdk'
import DOMPurify from 'dompurify'

import { getLinkUrl, getColor, isScreenSmall, getMargins } from '../../utility'

import { Title, Subtitle, Link2, LinkList } from '..'
import '../../../components/EmailSubscriptionCenter/Modal'

import './banner.css'
import { encodeForURL } from '../../../global/formatters/string-formatter'

export function BannerComplex({
  page,
  parameters,
  styles,
  blurb,
  height,
  renderIcons,
  bannerType,
}) {
  return (
    <div
      id={blurb.title?.replace(/[^A-Za-z]/g, '').toLowerCase()}
      className={`Banner2 u-posRelative ${
        bannerType ? `bannerType-${bannerType}` : ''
      } ${
        parameters.derived?.isCallout
          ? 'u-decoBorderLight u-decoBorderResetBottom'
          : ''
      } ${getMargins(parameters.marginTop, parameters.marginBottom)}`}
      style={{ minHeight: blurb.imageUrl || blurb.videoId ? height : null }}
    >
      <BrManageContentButton content={blurb.document} />
      <div
        className={`u-flex u-flexWrap ${
          styles.outerBackground ? styles.backgroundColor : ''
        }`}
      >
        {(blurb.imageUrl ||
          (!styles.outerBackground && parameters.backgroundColor)) && (
          <div
            id="banner-background-image"
            className={`u-posAbsolute ${
              parameters.derived?.isCallout ? 'u-sm-posRelative' : ''
            } ${styles.imageSize || ''} ${
              (!blurb.imageUrl || parameters.style === 'Icon') &&
              parameters.backgroundColor
                ? styles.backgroundColor
                : ''
            } ${styles.backgroundSize || ''}`}
            style={{
              backgroundImage:
                blurb.imageUrl && parameters.style !== 'Icon'
                  ? 'url("' + encodeForURL(blurb.imageUrl) + '")'
                  : null,
              backgroundRepeat: 'no-repeat',
              backgroundSize: 'cover',
              backgroundPosition: 'center top',
              top: 0,
              left: styles.leftPosition,
              right: styles.rightPosition,
              minHeight: isScreenSmall() ? height : '',
              height:
                (blurb.imageUrl && parameters.style !== 'Icon') ||
                isScreenSmall()
                  ? '100%'
                  : height,
            }}
            role="img"
            aria-label={blurb.imageDescription || 'banner'}
          />
        )}
        {(blurb.title ||
          blurb.subtitle ||
          blurb.html ||
          blurb.link?.url ||
          blurb.link?.href ||
          blurb.videoId ||
          (blurb.imageUrl && parameters.style === 'Icon')) && (
          <div
            className={`outerContainer u-posRelative u-sizeFull ${
              !parameters.derived?.isList ? styles.outerSize : ''
            } ${
              (parameters.position === 'Left' ||
                parameters.position === 'Right') &&
              blurb.imageUrl &&
              !parameters.derived?.isCallout
                ? 'u-sm-bgColorShaded'
                : ''
            } ${parameters.derived?.isQuote ? 'u-sm-transformUp50' : ''}`}
            style={{
              top: 0,
              bottom: 0,
              zIndex: 1,
              minHeight:
                (blurb.imageUrl ||
                  parameters.backgroundColor ||
                  blurb.videoId) &&
                !parameters.derived?.isList &&
                (!parameters.derived?.isCallout || !isScreenSmall())
                  ? height
                  : 'auto',
            }}
          >
            <div
              className={`u-flex u-flexCol ${styles.position || ''} ${
                styles.alignment || ''
              }`}
              style={{ height: '100%' }}
            >
              {blurb.imageUrl && parameters.style === 'Icon' && (
                <img src={encodeForURL(blurb.imageUrl)} alt="" />
              )}
              <div className={`u-flex u-sizeFull ${styles.position2 || ''}`}>
                <div
                  className={`u-flex u-flexCol textOverlay ${
                    styles.alignment || ''
                  } ${
                    (blurb.imageUrl &&
                      (styles.textBackgroundColor || styles.backgroundColor)) ||
                    ''
                  } ${
                    (parameters.position === 'Left' ||
                      parameters.position === 'Right') &&
                    blurb.imageUrl &&
                    !parameters.derived?.isCallout
                      ? 'u-sm-bgColorTransparent'
                      : ''
                  } ${styles.innerSize || ''} ${styles.paddingVert || ''} ${
                    styles.paddingHoriz || ''
                  } ${styles.borderColor || ''}`}
                >
                  {blurb.subtitle &&
                    (parameters.derived?.isSubheadingAbove ||
                      parameters.derived?.isCallout) && (
                      <Subtitle
                        text={blurb.subtitle}
                        textColor={styles.secondaryColor}
                        textSize={styles.subtitleSize}
                        lineColor={getColor(blurb.keys)}
                        mode={`${
                          parameters.derived?.isQuote
                            ? 'quote'
                            : getColor(blurb.keys)
                              ? 'line-left'
                              : 'line'
                        }`}
                      />
                    )}
                  {(blurb.itemType || blurb.time) &&
                    !(
                      parameters.derived?.isSubheadingAbove ||
                      parameters.derived?.isCallout
                    ) && (
                      <div className="u-flex u-flexAlignItemsCenter u-marginBottom4gu">
                        {renderIcons()}
                      </div>
                    )}
                  {blurb.title && (
                    <Title
                      text={blurb.title}
                      textColor={styles.textColor}
                      textAlign={styles.textAlign}
                      textSize={
                        parameters.position === 'Top Angled'
                          ? 'u-textSizeMsrp5 u-sm-textSizeMsrp4 u-md-textSizeMsrp4'
                          : (blurb.itemType || blurb.time) &&
                              !parameters.derived?.isCallout
                            ? 'u-textSizeMsrp4'
                            : parameters.derived?.isQuote
                              ? 'u-textSizeMsrp2'
                              : null
                      }
                      lineColor={getColor(blurb.keys)}
                      mode={
                        parameters.derived?.isCallout
                          ? 'medium-large'
                          : parameters.style !== 'Subheading Above' &&
                              !blurb.time &&
                              getColor(blurb.keys)
                            ? 'large-line-left'
                            : 'large'
                      }
                    />
                  )}
                  {blurb.publicationDate && (
                    <Subtitle
                      text={new Date(blurb.publicationDate).toLocaleDateString(
                        'en-us',
                        { year: 'numeric', month: 'long', day: 'numeric' }
                      )}
                      textColor={styles.textColor}
                      mode="small-bold"
                    />
                  )}

                  {blurb.subtitle &&
                    !(
                      parameters.derived?.isSubheadingAbove ||
                      parameters.derived?.isCallout
                    ) && (
                      <Subtitle
                        text={blurb.subtitle}
                        textColor={styles.secondaryColor}
                        textAlign={styles.textAlign}
                        textSize={
                          blurb.publicationDate
                            ? 'u-textSizeMsr u-textOpen'
                            : styles.subtitleSize
                        }
                        mode="medium"
                      />
                    )}
                  {blurb.html && (
                    <div
                      className={`Content ${styles.contentColor || ''} ${
                        styles.textAlign || ''
                      }`}
                      dangerouslySetInnerHTML={{
                        __html: DOMPurify.sanitize(
                          page.rewriteLinks(blurb.html)
                        ),
                      }}
                    />
                  )}
                  {(blurb.itemType || blurb.time) &&
                    (parameters.derived?.isSubheadingAbove ||
                      parameters.derived?.isCallout) && (
                      <div className="u-flex u-flexAlignItemsCenter u-marginTop4gu">
                        {renderIcons()}
                      </div>
                    )}

                  {blurb?.subscriptionCenter?.active && (
                    <email-subscription-modal
                      data-use-unlabeled-button="true"
                      data-subscription-name={blurb.subscriptionCenter.name}
                      {...(parameters.style === 'raspberry'
                        ? { raspberry: true }
                        : { tertiary: true })}
                    ></email-subscription-modal>
                  )}
                  <div className={`u-flex u-flexAlignItemsCenter`}>
                    {blurb.link?.text && (
                      <div
                        className={`${
                          parameters.position === 'Top Angled'
                            ? 'u-marginTop6gu'
                            : 'u-marginTop2gu'
                        }`}
                      >
                        <Link2
                          url={getLinkUrl(blurb.link)}
                          text={blurb.link.text}
                          icon={blurb.link.icon}
                          arrow={styles.arrow}
                          className={`Link ${styles.buttonColor} ${styles.hover}`}
                          textClasses={`u-textSecondary u-textKernLoose`}
                          {...(blurb.link.analyticsAttribute
                            ? {
                                'data-analytics-attribute':
                                  blurb.link.analyticsAttribute,
                              }
                            : {})}
                        />
                      </div>
                    )}
                    {blurb.linkList && blurb.linkList.length > 0 && (
                      <LinkList
                        linkList={blurb.linkList}
                        buttonClass={`${styles.buttonColor} ${styles.buttonClass}`}
                        buttonColor={styles.buttonColor}
                        spacingClass="u-marginLeft5gu"
                      />
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  )
}

BannerComplex.propTypes = {
  page: PropTypes.object.isRequired,
  parameters: PropTypes.object.isRequired,
  styles: PropTypes.object,
  blurb: PropTypes.object,
  height: PropTypes.number,
  renderIcons: PropTypes.func,
  bannerType: PropTypes.string,
}
